import { render, staticRenderFns } from "./AppCopyableText.vue?vue&type=template&id=4c899513&scoped=true"
import script from "./AppCopyableText.vue?vue&type=script&lang=js"
export * from "./AppCopyableText.vue?vue&type=script&lang=js"
import style0 from "./AppCopyableText.vue?vue&type=style&index=0&id=4c899513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c899513",
  null
  
)

export default component.exports